var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../store/actions';
import { AppBar, Hidden, Icon, IconButton, Toolbar, Drawer, MuiThemeProvider } from '@material-ui/core';
import Scrollbars from '../../components/Scrollbars';
import Message from '../../components/Message';
import { themes } from '../../theme';
import * as classNames from 'classnames';
var defaultProps = {};
var navbarWidth = 256;
var styles = function (theme) {
    var _a, _b;
    return ({
        root: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            '&.boxed': {
                maxWidth: 1280,
                margin: '0 auto',
                boxShadow: theme.shadows[3],
            },
        },
        content: {
            display: 'flex',
            overflow: 'overlay !important',
            flex: '1 1 auto',
            flexDirection: 'column',
            width: '100%',
            '-webkit-overflow-scrolling': 'touch',
            zIndex: 4,
        },
        navbarWrapper: {
            boxShadow: theme.shadows[3],
            zIndex: 6,
        },
        navbarPaperWrapper: {},
        navbar: {
            display: 'flex',
            overflow: 'hidden',
            height: 56,
            zIndex: 6,
        },
        navbarMobile: {
            display: 'flex',
            overflow: 'hidden',
            flexDirection: 'column',
            width: navbarWidth,
            minWidth: navbarWidth,
            height: '100%',
            zIndex: 4,
            transition: theme.transitions.create(['width', 'min-width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.shorter,
            }),
        },
        navbarButton: {
            '&.right': {
                borderLeft: '1px solid ' + theme.palette.divider,
            },
            '&.left': {
                borderRight: '1px solid ' + theme.palette.divider,
            },
        },
        navbarHeaderWrapper: (_a = {
                display: 'flex',
                alignItems: 'center',
                flex: '0 0 auto'
            },
            _a[theme.breakpoints.down('md')] = __assign(__assign({ flex: '0 1 auto' }, theme.mixins.toolbar), { backgroundColor: 'rgba(255, 255, 255, .05)', boxShadow: theme.shadows[1] }),
            _a),
        navbarHeader: {
            display: 'flex',
            flex: '1 0 auto',
            padding: '0 8px 0 16px',
        },
        navbarContent: (_b = {},
            _b[theme.breakpoints.down('md')] = {
                overflowX: 'hidden',
                overflowY: 'auto',
            },
            _b['-webkit-overflow-scrolling'] = 'touch',
            _b),
        toolbarWrapper: {
            display: 'flex',
            position: 'relative',
            zIndex: 5,
        },
        toolbar: {
            display: 'flex',
            flex: '1 0 auto',
        },
        footerWrapper: {
            position: 'relative',
            zIndex: 5,
        },
        footer: {
            display: 'flex',
            flex: '1 0 auto',
        },
    });
};
var Layout2 = /** @class */ (function (_super) {
    __extends(Layout2, _super);
    function Layout2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Layout2.prototype.render = function () {
        var _a = this.props, classes = _a.classes, toolbar = _a.toolbar, footer = _a.footer, navbarHeader = _a.navbarHeader, navbarContent = _a.navbarContent, settings = _a.settings, navbar = _a.navbar, navbarOpenMobile = _a.navbarOpenMobile, navbarCloseMobile = _a.navbarCloseMobile;
        var layoutConfig = settings.layout.config;
        var navbarHeaderTemplate = (React.createElement("div", { className: classes.navbarHeaderWrapper },
            React.createElement("div", { className: classes.navbarHeader }, navbarHeader),
            React.createElement(Hidden, { lgUp: true },
                React.createElement(IconButton, { onClick: navbarCloseMobile },
                    React.createElement(Icon, null, "menu")))));
        var navbarContentTemplate = React.createElement("div", { className: classes.navbarContent }, navbarContent);
        var navBarTemplate = (React.createElement(MuiThemeProvider, { theme: themes[settings.theme.navbar] },
            React.createElement("div", { id: "fuse-navbar", className: classes.navbarWrapper },
                React.createElement(Hidden, { mdDown: true },
                    React.createElement("div", { className: classNames(classes.navbar), style: { backgroundColor: themes[settings.theme.navbar].palette.background.default } },
                        navbarHeaderTemplate,
                        navbarContentTemplate)),
                React.createElement(Hidden, { lgUp: true },
                    React.createElement(Drawer, { anchor: "left", variant: "temporary", open: navbar.mobileOpen, classes: {
                            paper: classes.navbarMobile,
                        }, onClose: navbarCloseMobile, ModalProps: {
                            keepMounted: true, // Better open performance on mobile.
                        } },
                        navbarHeaderTemplate,
                        navbarContentTemplate)))));
        var toolbarTemplate = (React.createElement(MuiThemeProvider, { theme: themes[settings.theme.toolbar] },
            React.createElement(AppBar, { id: "fuse-toolbar", className: classNames(classes.toolbarWrapper), color: "default" },
                React.createElement(Toolbar, { className: "p-0" },
                    layoutConfig.navbar.position === 'left' && (React.createElement(Hidden, { lgUp: true },
                        React.createElement(IconButton, { id: "menu-btn-left", className: classNames(classes.navbarButton, 'w-64 h-64 rounded-none', layoutConfig.navbar.position), "aria-label": "open drawer", onClick: navbarOpenMobile },
                            React.createElement(Icon, null, "menu")))),
                    React.createElement("div", { className: classes.toolbar }, toolbar),
                    layoutConfig.navbar.position === 'right' && (React.createElement(Hidden, { lgUp: true },
                        React.createElement(IconButton, { id: "menu-btn-right", className: classNames(classes.navbarButton, 'w-64 h-64 rounded-none', layoutConfig.navbar.position), "aria-label": "open drawer", onClick: navbarOpenMobile },
                            React.createElement(Icon, null, "menu"))))))));
        var footerTemplate = (React.createElement(MuiThemeProvider, { theme: themes[settings.theme.footer] },
            React.createElement(AppBar, { id: "fuse-footer", className: classNames(classes.footerWrapper), color: "default" },
                React.createElement(Toolbar, { className: "p-0" },
                    React.createElement("div", { className: classNames(classes.footer) }, footer)))));
        return (React.createElement("div", { id: "fuse-layout", className: classNames(classes.root, layoutConfig.mode) },
            layoutConfig.toolbar.display && layoutConfig.toolbar.position === 'above' && toolbarTemplate,
            layoutConfig.navbar.display && navBarTemplate,
            layoutConfig.toolbar.display && layoutConfig.toolbar.position === 'below' && toolbarTemplate,
            React.createElement(Scrollbars, { className: classes.content },
                React.createElement(Message, null),
                renderRoutes(this.props.routes),
                layoutConfig.footer.display && layoutConfig.footer.style === 'static' && footerTemplate),
            layoutConfig.footer.display && layoutConfig.footer.style === 'fixed' && footerTemplate));
    };
    Layout2.defaultProps = defaultProps;
    return Layout2;
}(React.PureComponent));
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setSettings: Actions.setSettings,
        setDefaultSettings: Actions.setDefaultSettings,
        resetSettings: Actions.resetSettings,
        navbarOpenFolded: Actions.navbarOpenFolded,
        navbarCloseFolded: Actions.navbarCloseFolded,
        navbarOpenMobile: Actions.navbarOpenMobile,
        navbarCloseMobile: Actions.navbarCloseMobile,
    }, dispatch);
}
function mapStateToProps(_a) {
    var fuse = _a.fuse;
    return {
        defaultSettings: fuse.settings.defaults,
        settings: fuse.settings.current,
        navbar: fuse.navbar,
    };
}
// @ts-ignore
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout2)));



//////////////////
// WEBPACK FOOTER
// ./src/theme/layout/layouts/Layout2.tsx
// module id = 1454
// module chunks = 81